<template>
  <a-spin :spinning="pageLoading" tip="Loading...">
    <a-form :form="form">
      <a-row :gutter="16">
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Used For">
            <a-radio-group
              buttonStyle="solid"
              @change="selectRadio"
              :disabled="mode==='Edit'"
              v-decorator="['peruntukan', {rules: [{required: true}], initialValue: initialData.peruntukan}]"
            >
              <a-radio-button
                v-for="item in peruntukan"
                :key="item.id"
                :value="item.value"
              >{{item.value}}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="Sales Notification">
            <a-select
              showSearch
              allowClear
              @change="handleSales"
              :disabled="enabledSN"
              v-decorator="['sales_notification', {rules: [{required: false}], initialValue: initialData.sales_notification}]"
            >
              <a-select-option
                v-for="item in salesNotification"
                :key="item.no_salesnotif"
              >{{item.no_salesnotif}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Project Code">
            <a-input
              :disabled="mode==='Edit'"
              maxlength="6"
              v-decorator="['kode_proyek', {rules: [{required: true}], initialValue: initialData.kode_proyek}]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Project Name">
            <a-input
              v-decorator="['nama_proyek', {rules: [{required: true}], initialValue: initialData.nama_proyek}]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Duration">
            <a-range-picker
              :format="getDefaultDateFormat"
              :placeholder="['Start month', 'End month']"
              v-decorator="['durasi', {rules: [{type: 'array', required: true}], initialValue: [moment(initialData.durasi[0], getStandartFormatDate), moment(initialData.durasi[1], getStandartFormatDate)]}]"
            ></a-range-picker>
          </a-form-item>
        </a-col>
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Client">
            <a-input
              v-decorator="['klien', {rules: [{required: true}], initialValue: initialData.klien}]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Company">
            <a-select
              showSearch
              v-decorator="['perusahaan', {rules: [{required: true}], initialValue: initialData.perusahaan}]"
            >
              <a-select-option v-for="item in perusahaan" :key="item.value">{{item.text}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Site">
            <a-radio-group
              buttonStyle="solid"
              v-decorator="['site', {rules: [{required: true}], initialValue: initialData.site}]"
            >
              <a-radio-button value="Surabaya">Surabaya</a-radio-button>
              <a-radio-button value="Jakarta">Jakarta</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="Status">
            <a-radio-group
              :disabled="initialData.active_sts==='1'"
              buttonStyle="solid"
              v-decorator="['active_sts', {rules: [{required: true}], initialValue: initialData.active_sts}]"
            >
              <a-radio-button value="1">Active</a-radio-button>
              <a-radio-button value="0">Non Active</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="Project Leader">
            <a-select
              showSearch
              v-decorator="['pimpinan_proyek', {rules: [{required: true}], initialValue: initialData.pimpinan_proyek}]"
            >
              <a-select-option
                v-for="item in getAllKaryawan"
                :key="item.tlc"
                :value="item.tlc"
              >{{item.tlc}} - {{item.nama}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Account Manager">
            <a-select
              showSearch
              allowClear
              v-decorator="['akun_manajer', {rules: [{required: checkPeruntukan}], initialValue: initialData.akun_manajer}]"
            >
              <a-select-option
                v-for="item in akunManager"
                :key="item.tlc"
              >{{item.tlc}} - {{item.nama}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-spin>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "header",
  props: {
    data: {},
    mode: "",
    info: ""
  },
  data() {
    return {
      pageLoading: true,
      salesNotification: [],
      perusahaan: [],
      akunManager: [],
      peruntukan: [],
      checkAccountManger: true,
      peruntukanSelected: ""
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    if (this.mode === "Edit") {
      this.pageLoading = false;
    }
    this.peruntukanSelected = this.data ? this.data.peruntukan : "";
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getAllKaryawan",
      "getStandartFormatDate"
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          sales_notification: "",
          kode_proyek: "",
          nama_proyek: "",
          durasi: [moment(), moment()],
          klien: "",
          perusahaan: "",
          site: "",
          pimpinan_proyek: "",
          akun_manajer: "",
          peruntukan: "Customer",
          jenis: "",
          active_sts: "1",
        };
      } else {
        return {
          sales_notification: this.data.sales_notification,
          kode_proyek: this.data.kode_proyek,
          nama_proyek: this.data.nama_proyek,
          durasi: [this.data.durasi[0], this.data.durasi[1]],
          klien: this.data.klien,
          perusahaan: this.data.perusahaan,
          site: this.data.site,
          pimpinan_proyek: this.data.pimpinan_proyek,
          akun_manajer: this.data.akun_manajer,
          peruntukan: this.data.peruntukan,
          jenis: this.info,
          active_sts: this.data.active_sts.toString(2),
        };
      }
    },
    checkPeruntukan() {
      if (this.peruntukanSelected) {
        if (this.peruntukanSelected === "Non Project") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    enabledSN() {
      if (this.peruntukanSelected) {
        if (this.peruntukanSelected !== "Customer") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    checkSN() {
      if (this.peruntukanSelected) {
        this.form.setFieldsValue({
          sales_notification: undefined
        });
        if (this.peruntukanSelected !== "Customer") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  },
  methods: {
    moment,
    fetchingData() {
      const salesNotification = axios({
        method: "get",
        url: this.$serviceUrl + "project/sales_notification",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const perusahaan = axios({
        method: "get",
        url: this.$serviceUrl + "main/getPerusahaan",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const akunManager = axios({
        method: "get",
        url: this.$serviceUrl + "project/akun_manajer",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const peruntukan = axios({
        method: "get",
        url: this.$serviceUrl + "main/peruntukan",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      return axios
        .all([
          salesNotification.catch(err => {
            return null;
          }),
          perusahaan.catch(err => {
            return null;
          }),
          akunManager.catch(err => {
            return null;
          }),
          peruntukan.catch(err => {
            return null;
          })
        ])
        .then(response => {
          if (response[0] !== undefined) {
            this.salesNotification = response[0].data.data;
          } else {
            this.salesNotification = [];
          }
          if (response[1] !== undefined) {
            this.perusahaan = response[1].data.data;
          } else {
            this.perusahaan = [];
          }
          if (response[2] !== undefined) {
            this.akunManager = response[2].data.data;
          } else {
            this.akunManager = [];
          }
          if (response[3] !== undefined) {
            this.peruntukan = response[3].data.data;
          } else {
            this.peruntukan = [];
          }

          this.pageLoading = false;
        })
        .catch(err => {
          // this.pageLoading = false;
        });
    },
    handleSales(val) {
      if (val) {
        let output = "";
        output = this.salesNotification.filter(
          obj =>
            obj.no_salesnotif &&
            obj.no_salesnotif.toLowerCase().indexOf(val.toLowerCase()) >= 0
        );
        this.initialData.jenis = output[0].jenis;
      } else {
        this.initialData.jenis = undefined;
      }
    },
    handleRef() {
      this.handleSales(this.form.getFieldValue("sales_notification"));
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let projectValue = [];
        projectValue.push(
          moment(values.durasi[0]).format(this.getStandartFormatDate)
        );
        projectValue.push(
          moment(values.durasi[1]).format(this.getStandartFormatDate)
        );

        values.durasi = projectValue;

        Event.$emit("projectrab", {
          project: values,
          jenis: this.initialData.jenis
        });
      });
    },
    selectRadio(e) {
      this.peruntukanSelected = e.target.value;
      // this.initialData.peruntukan = this.peruntukanSelected;
    }
  },
  mounted() {
    this.fetchingData();
  }
};
</script>

<style lang="less" scoped>
</style>